import * as RestAPI from 'lib/rest_api'

export const saveReferenceAvatars = (projectId, specId, referenceAvatars) => {
  return RestAPI.POST(
    `/projects/${projectId}/sizespecs/${specId}/avatars`,
    referenceAvatars
  )
}
